window.setTimeout(function() {
    $(document).ready(function(e) { 
    	
    	(function($) {
              'use strict';
              // call our plugin
              var Nav = new hcOffcanvasNav('#main-nav #menu-main-menu', {
                disableAt: false,
                customToggle: '.toggle',
                levelSpacing: 50,
                //navTitle: 'All Categories',
                levelTitles: true,
                levelTitleAsBack: true,
                pushContent: '#container-box',
                labelClose: false
              });
    
        })(jQuery);
    	
    	////////////
    	if($('#banner-slider').length){
    		$('#banner-slider').owlCarousel({
    			autoplay:true,
    			dots: false,
    			nav: false,
    			navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
    			rewind:true,
    			autoplayTimeout:5000,
    			loop:true,
    			items:1,
    			margin:0,
    			responsive:{
    			  200:{ items:1 },
    			  300:{ items:1 },
    			  630:{ items:1 },
    			  980:{ items:1 }
    			}
    		});
    	}
    	////////////
    	if($('#review-slider2').length){
    		$('#review-slider2').owlCarousel({
    			autoplay:true,
    			dots: false,
    			nav: false,
    			navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
    			rewind:true,
    			autoplayTimeout:4000,
    			loop:true,
    			items:1,
    			margin:0,
    			responsive:{
    			  200:{ items:1 },
    			  300:{ items:1 },
    			  630:{ items:1 },
    			  980:{ items:1 }
    			}
    		});
    	}
    	////////////
    	if($('.best-seller').length){
    		$('.best-seller').owlCarousel({
    			autoplay:false,
    			dots: false,
    			nav: true,
    			navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
    			rewind:true,
    			autoplayTimeout:5000,
    			loop:true,
    			items:2,
    			margin:20,
    			responsive:{
    			  200:{ items:2 },
    			  480:{ items:2 },
    			  600:{ items:2 }
    			}
    		});
    	}
    	
    	
    });

jQuery(jQuery(".login-box2").detach()).appendTo(".nav-container .nav-content .nav-close");  
}, 25);
    
$(document).ready(function(e) {
  $(".single-produc-details").click(function(){
    $(this).siblings('.single-product-details').slideToggle();
  }); 
});

 let tickerSpeed = 2;

let flickity = null;
let isPaused = false;
const slideshowEl = document.querySelector('.js-slideshow');


//
//   Functions
//
//////////////////////////////////////////////////////////////////////

/*const update = () => {
  if (isPaused) return;
  if (flickity.slides) {
    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    flickity.settle(flickity.x);
  }
  window.requestAnimationFrame(update);
};

const pause = () => {
  isPaused = true;
};

const play = () => {
  if (isPaused) {
    isPaused = false;
    window.requestAnimationFrame(update);
  }
};


//
//   Create Flickity
//
//////////////////////////////////////////////////////////////////////

flickity = new Flickity(slideshowEl, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: false,
  wrapAround: true,
  selectedAttraction: 0.0015,
  friction: 0.00028
});
flickity.x = 0;


//
//   Add Event Listeners
//
//////////////////////////////////////////////////////////////////////

slideshowEl.addEventListener('mouseenter', pause, false);
slideshowEl.addEventListener('focusin', pause, false);
slideshowEl.addEventListener('mouseleave', play, false);
slideshowEl.addEventListener('focusout', play, false);

flickity.on('dragStart', () => {
  isPaused = true;
});


//
//   Start Ticker
//
//////////////////////////////////////////////////////////////////////

update(); */
